module.exports = __webpack_public_path__ + "img/4club-09.47e99809.svg";